import React, { useState } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {
    Box,
    Card,
    Chip,
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    makeStyles
    // IconButton
} from '@material-ui/core'
// import { Delete, Visibility } from '@material-ui/icons'
// import firebase from "firebase/app";

const useStyles = makeStyles((theme) => ({
    root: {},
    avatar: {
        marginRight: theme.spacing(2)
    }
}))

const Results = (props) => {
    const {
        className,
        users,
        page,
        setPage,
        limit,
        setLimit,
        // appendNewUsers,
        // noMoreData,
        ...rest
    } = props
    const classes = useStyles()
    const [selectedCustomerIds, setSelectedCustomerIds] = useState([])
    const [shownUsers, setShownUsers] = useState()

    React.useEffect(() => {
        const _shownUsers = users
            .slice(0 + limit * page, limit * (page + 1))
            .map((user) => user.id)

        setShownUsers(_shownUsers)
    }, [limit, page, users])

    const handleSelectAll = (event) => {
        let newSelectedCustomerIds

        if (event.target.checked) {
            newSelectedCustomerIds = users
                .slice(0 + limit * page, limit * (page + 1))
                .map((user) => user.id)
        } else {
            newSelectedCustomerIds = []
        }

        setSelectedCustomerIds(newSelectedCustomerIds)
    }

    const handleSelectOne = (event, id) => {
        const selectedIndex = selectedCustomerIds.indexOf(id)
        let newSelectedCustomerIds = []

        if (selectedIndex === -1) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedCustomerIds,
                id
            )
        } else if (selectedIndex === 0) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedCustomerIds.slice(1)
            )
        } else if (selectedIndex === selectedCustomerIds.length - 1) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedCustomerIds.slice(0, -1)
            )
        } else if (selectedIndex > 0) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedCustomerIds.slice(0, selectedIndex),
                selectedCustomerIds.slice(selectedIndex + 1)
            )
        }

        setSelectedCustomerIds(newSelectedCustomerIds)
    }

    const handleLimitChange = (event) => {
        setLimit(event.target.value)
        if (event.target.value * page > users.length) {
            const _newPage = Math.floor(users.length / event.target.value)
            setPage(_newPage)
        }
    }

    const handlePageChange = (event, newPage) => {
        setPage(newPage)
    }

    return (
        <Card className={clsx(classes.root, className)} {...rest}>
            <PerfectScrollbar>
                <Box minWidth={1050}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell padding="checkbox">
                                    <Checkbox
                                        checked={
                                            JSON.stringify(
                                                selectedCustomerIds
                                            ) === JSON.stringify(shownUsers)
                                        }
                                        color="primary"
                                        indeterminate={false}
                                        onChange={handleSelectAll}
                                    />
                                </TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Role</TableCell>
                                <TableCell>Status</TableCell>
                                {/* <TableCell>Actions</TableCell> */}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {users
                                .slice(0 + limit * page, limit * (page + 1))
                                .map((user) => (
                                    <TableRow
                                        hover
                                        key={user.id}
                                        selected={selectedCustomerIds.includes(
                                            user.id
                                        )}
                                    >
                                        <TableCell padding="checkbox">
                                            <Checkbox
                                                checked={selectedCustomerIds.includes(
                                                    user.id
                                                )}
                                                onChange={(event) =>
                                                    handleSelectOne(
                                                        event,
                                                        user.id
                                                    )
                                                }
                                                value="true"
                                            />
                                        </TableCell>
                                        <TableCell>{user.email}</TableCell>
                                        <TableCell>
                                            <Chip
                                                color="primary"
                                                label={user.role}
                                                size="small"
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Chip
                                                color={
                                                    user.status === 'active'
                                                        ? 'primary'
                                                        : 'default'
                                                }
                                                label={user.status}
                                                size="small"
                                            />
                                        </TableCell>
                                        {/* <TableCell>
                                            <IconButton>
                                                <Visibility />
                                            </IconButton>
                                            <IconButton>
                                                <Delete />
                                            </IconButton>
                                        </TableCell> */}
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </Box>
            </PerfectScrollbar>
            <TablePagination
                component="div"
                count={users.length}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handleLimitChange}
                page={page}
                rowsPerPage={limit}
                rowsPerPageOptions={[5, 10, 25]}
            />
        </Card>
    )
}

Results.propTypes = {
    className: PropTypes.string,
    users: PropTypes.array.isRequired,
    limit: PropTypes.number,
    setLimit: PropTypes.func,
    page: PropTypes.number,
    setPage: PropTypes.func,
    appendNewUsers: PropTypes.func,
    noMoreData: PropTypes.bool
}

// Results.propTypes = {
//   className: PropTypes.string,
//   users: PropTypes.array.isRequired
// };

export default Results
